import React, { createContext, useContext, useReducer } from 'react';

export const SocialContext = createContext();

export const SocialProvider = ({ reducer, initialState, children }) => (
  <SocialContext.Provider value={useReducer(reducer, initialState)}>{children}</SocialContext.Provider>
);

export const useSocialState = () => useContext(SocialContext);
